export const MODULE_OPTIONS = ["Base", "Bachelor", "Master"];

export const BRANCH_OPTIONS = [
  { value: "AE", label: "Agriculture Eng. (AE)" },
  { value: "CE", label: "Civil Eng. (CE)" },
  { value: "CSE", label: "Computer Science (CSE)" },
  { value: "EE", label: "Electrical Eng. (EE)" },
  { value: "ECE", label: "Electronics & Comm. (ECE)" },
  { value: "ME", label: "Mechanical Eng. (ME)" },
];

export const SEMESTER_OPTIONS = ["Mid", "End"];
export const CYCLE_OPTIONS = ["Jan-Jun", "Jul-Dec"];
export const PAPER_PAGE_SIZE = 10;
